module.exports = __webpack_public_path__ + "static/media/image-1.be045cee.jpg";